import { Component, EventEmitter, Input, Output } from '@angular/core'
import { NgClass, TitleCasePipe } from '@angular/common';
import { NgCircleProgressModule } from 'ng-circle-progress'

import { ResponsiveComponent } from '@nx-superprep/shared'

import { CompletionState } from '../completion-state';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu'

@Component({
  selector: 'pop-ui-home-status-tile',
  standalone: true,
  imports: [NgClass, TitleCasePipe, NgCircleProgressModule, TourMatMenuModule],
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.scss'],
})
export class StatusTileComponent extends ResponsiveComponent {
  private _state!: CompletionState
  @Input()
  get state(): CompletionState {
    return this._state
  }
  set state(value: CompletionState) {
    if (!value) { return }
    this._state = value
    if (!this.isWeb) { this._state.selected = 'today' }
    this._label = !this._state.activeDate || this._state.activeDate.isToday() ? 'today' : this._state.activeDate.format('dddd')
  }
  @Output() stateChange = new EventEmitter<CompletionState>()

  get titleFontSize() { return this.isWeb ? '35' : this.percent < 100 ? '33' : '30' }
  titleFontWeight = '700'
  backgroundStroke = 'white'
  innerStrokeColor = '#00000014'
  outerStrokeColor = '#23CE6B'
  outerStrokeGradientStopColor = '#FFBE0B'
  outerStrokeWidth = 8
  innerStrokeWidth = 4

  get title() {
    return String(this.percent)+'%'
  }

  get titleColor() {
    return this.isWeb ? 'black' : 'white'
  }

  get radius() {
    return this.isWeb ? 62 : 48
  }

  get percent() {
    return Math.round(
      Math.max(
        0,
        Math.min(
          1,
          this.selected === 'today' ? Number(this.state?.completed?.today ?? 0)||0 : Number(this.state?.completed?.overall ?? 0)||0
        )
      ) * 100)
  }

  private _label = 'today'
  get label() {
    return this.selected === 'overall' ? 'overall' : this._label
  }
  set label(value) {
    this._label = value
  }

  get selected() {
    return this.state?.selected ?? 'today'
  }
  set selected(value: 'today' | 'overall') {
    if (!this.state) { return }
    this.state.selected = value
    this.stateChange.emit(this.state)
  }

  get titleLine1() {
    return this.isWeb
    ? this.selected === `today` ? `${this._label}'s` : `Overall`
    : this.selected === `today` ? `Session` : `Learning`
  }

  get titleLine2() {
    return this.isWeb
    ? this.selected === `today` ? `Session Completion` : `Learning Progress`
    : this.selected === `today` ? `Completion` : `Progress`
  }

  onToggle() {
    this.selected = this.selected === 'today' ? 'overall' : 'today'
  }
}
